<ng-container *ngIf="evento as m">
  <div class="od-alert od-alert-mal" role="alert" *ngIf="!m.ok">
    <od-icon name="alert" [size]="16"></od-icon>
    <div class="od-alert-tx"><b>Qué falló</b><p style="margin:2px 0 0; overflow-wrap: anywhere">{{ m.motivo || tecnico?.error || m.simple }}</p></div>
  </div>

  <section class="od-cd">
    <div class="od-cd-h"><h5>Qué pasó</h5></div>
    <div class="od-cd-b">
      <p style="margin: 0">{{ m.simple }}</p>
      <p class="od-muted" style="margin: 6px 0 0">{{ respuestaSimple(m) }}</p>
    </div>
  </section>

  <div class="od-cd od-trio">
    <div><span>Cuánto tardó</span><b>{{ duracion(m.duracion_ms) }}</b></div>
    <div><span>Quién</span><b>{{ m.quien || 'Automático' }}</b></div>
    <div><span>Código HTTP</span><b>{{ (tecnico?.status ?? m.status) || '—' }}</b></div>
  </div>

  <ng-container *ngIf="cargando">
    <div class="od-skeleton" style="height: 120px" aria-busy="true"></div>
    <div class="od-skeleton" style="height: 120px" aria-busy="true"></div>
  </ng-container>
  <div class="od-alert od-alert-mal" role="alert" *ngIf="error">
    <od-icon name="alert" [size]="16"></od-icon>
    <div class="od-alert-tx">{{ error }}</div>
  </div>
  <ng-container *ngIf="tecnico as t">
    <od-kv titulo="Lo que se envió" [datos]="t.peticion" vacio="Nada: no llegó a enviarse."></od-kv>
    <od-kv titulo="Lo que respondió Odoo" [datos]="t.respuesta" vacio="Odoo no devolvió respuesta."></od-kv>
  </ng-container>
</ng-container>
